import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.dataPatientChildDepartment.loading;
export const selectErrorMessage = (state: RootState) =>
  state.dataPatientChildDepartment.error;
export const dataPatientChildDepartmentResponse = (state: RootState) =>
  state.dataPatientChildDepartment.dataPatientChildDepartmentResponse;
